<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="h3 mb-3 text-gray-800">Mapas</h1>
    </div>
    <load v-if="loading" />
    <div v-else class="col-md-12">
      <div class="row">
        <Sidebar @tipo="getTipo" />
        <BI v-if="showBI" />
        <div v-else class="col-md-9 card card-body shadow p-2 mb-0">
          <div v-if="loadingMap" class="p-f text-center">
            <h2>Aguarde um instante !</h2>
            <h2>os endereços estão sendo carregados no mapa.</h2>
            <load mode="table" />
          </div>
          <div class="row px-3">
            <div
              class="col-12 p-2 d-flex align-items-centerd-flex align-items-center justify-content-between alert alert-warning alert-dismissible fade show"
              role="alert"
              v-if="showAlert"
              style="color: #323232"
            >
              <span
                >Apenas famílias com o
                <strong>
                  endereço devidamente preenchido e que contenha as informações
                  de geolocalização
                </strong>
                serão contabilizadas e carregadas no mapa!
              </span>
              <button
                class="float-right btn p-0 m-0"
                @click="showAlert = false"
              >
                <i class="mdi mdi-close mdi-18px text-warning"> </i>
              </button>
            </div>
          </div>
          <Mapa
            :center="center"
            :markers="markers"
            :programas="programas"
            :icon="icon"
            :filtroShow="true"
            :aba="abaSelected"
            :loadHome="loadingMap"
            @get-imagem="teste"
          />
          <!--
          <div class="row bg-danger">
						<b-button
							:title="$t('Visualizar e Imprimir')"
							to="/dashboard/mapa/show/"
							class="py-1"
							size="sm"
							type="button"
							v-b-tooltip.hover
							variant="primary"
						>
							<i class="mdi mdi-printer mdi-18px" />
						</b-button>
					</div>
          -->
        </div>
      </div>
      <h1></h1>
    </div>
  </div>
</template>
<script>
import Sidebar from "./includes/Sidebar";
import BI from "./BI";
import Mapa from "./includes/Mapa";
export default {
  components: { Sidebar, Mapa, BI },
  data() {
    return {
      loading: false,
      showBI: false,
      showAlert: true,
      loadingMap: true,
      abaSelected: "",
      tipo: "",
      center: {
        lat: this.$store.state.settings.app_cidade_lat,
        lng: this.$store.state.settings.app_cidade_lng,
      },
      markers: [],
      programas: [],
      icon: "",
      url: window.urlbase,
    };
  },
  methods: {
    teste(imagem) {
      //console.log(imagem);
    },
    getTipo(tipo, icon, aba) {
      this.tipo = tipo;
      this.icon = icon;
      this.abaSelected = aba;
      if (tipo == "bi") {
        this.showBI = true;
      } else {
        this.setCordenadas(tipo);
        this.showBI = false;
      }
    },
    setProgramas(programas) {
      let temp = programas.map((item) => {
        return {
          id: item.dados.programa_social,
          value: item.dados.programa_social,
        };
      });

      return [
        ...new Set(
          temp.map((data) => {
            return {
              id: data.id,
              value: data.value,
            };
          })
        ),
      ];
    },
    // onlyUnique(value, index, self) {
    //     return self.indexOf(value) === index;
    // },
    async setCordenadas(tipo) {
      if (tipo == "familias_cadastradas") {
        this.loadingMap = true;
        let response = await axios.get(
          `api/dashboard/mapa/familias/cadastradas`
        );

        this.markers = response.data;
        this.loadingMap = false;
      } else if (tipo == "familias_acompanhamento") {
        this.loadingMap = true;
        axios
          .get(`api/dashboard/mapa/familias/acompanhamento`)
          .then((response) => {
            this.markers = response.data;
          })
          .finally((response) => {
            this.loadingMap = false;
          });
      } else if (tipo == "familias_atendidas") {
        this.loadingMap = true;
        axios
          .get(`api/dashboard/mapa/familias/atendidas`)
          .then((response) => {
            this.markers = response.data;
          })
          .finally((response) => {
            this.loadingMap = false;
          });
      } else if (tipo == "programas") {
        this.loadingMap = true;
        axios
          .get(`api/dashboard/mapa/familias/programas`)
          .then((response) => {
            this.markers = response.data;
            this.programas = this.setProgramas(this.markers);
          })
          .finally((response) => {
            this.loadingMap = false;
          });
      } else if (tipo == "situacao_violacao") {
        this.loadingMap = true;
        axios
          .get(`api/dashboard/mapa/familias/situacao`)
          .then((response) => {
            this.markers = response.data;
          })
          .finally((response) => {
            this.loadingMap = false;
          });
      } else if (tipo == "vulnerabilidades") {
        this.loadingMap = true;
        axios
          .get(`api/dashboard/mapa/familias/vulnerabilidades`)
          .then((response) => {
            this.markers = response.data;
          })
          .finally((response) => {
            this.loadingMap = false;
          });
      } else if (tipo == "faixa_etaria") {
        this.loadingMap = true;
        axios
          .get(`api/dashboard/mapa/familias/faixaetaria`)
          .then((response) => {
            this.markers = response.data;
          })
          .finally((response) => {
            this.loadingMap = false;
          });
      }
    },
  },
};
</script>
